import { ConfirmModal } from 'components/modal/confirm-modal';
import { useSocialAccounts } from 'hooks';

type Props = {
  isVisible: boolean;
  onClose: () => void;
};

export const UnlinkGoogleConfirmModal = ({ isVisible, onClose }: Props) => {
  const { unlinkGoogle, isUnlinkGoogleLoading } = useSocialAccounts();

  return (
    <ConfirmModal
      onClose={onClose}
      isVisible={isVisible}
      headerTitle="Unlink Google account"
      title="Do you want to unlink your Google account?"
      confirmButtonTitle={isUnlinkGoogleLoading ? 'Loading...' : 'Confirm'}
      onSubmit={async () => {
        await unlinkGoogle();
        onClose();
      }}
    />
  );
};
